<template>

<v-content class="mt-12">
    <v-card
        width=600
        flat
        dark
        class="mx-auto blueMain">
        <div class="text-center my-2 blueGrey--text">
            <v-icon class="blueGrey--text">store</v-icon>
            Магазины
        </div>

<!-- Shops card -->
        <v-card
            dark
            class="blueDark">
            <div class="text-center pt-6"
                 v-if="totalInfo.factToday">
                за день
                <span class="ml-2 orangeMain--text">{{ totalInfo.factToday | moneyT }} ₽</span>
            </div>
            <v-expansion-panels
                accordion
                dark
                flat
                focusable>
                <v-expansion-panel
                    v-for="shopid in totalInfo.shoplist"
                    :key="shopid"
                    class="blueDark">
                    <v-expansion-panel-header>
                        <div class="">
                            {{shopinfo[shopid].shopname.split(' ')[0]}}
                        </div>
                        <div class="orangeMain--text">
                            {{shopinfo[shopid].shopname.split(' ').slice(1,).join(' ')}}
                        </div>
                    </v-expansion-panel-header>

                    <v-lazy
                        :options="{ threshold: .5 }"
                        transition="fade-transition">

                        <Shop :shopid="shopid"/>

                    </v-lazy>
                </v-expansion-panel>
            </v-expansion-panels>
        </v-card>
    </v-card>
</v-content>

</template>

<script>

import Shop from './shop'
import {mapState, mapMutations} from 'vuex';


export default {
name: 'ShopList',
components: {
    Shop
},
data: () => ({
}),

computed: {
  ...mapState(['totalInfo', 'shopinfo']),

},

methods: {

  ...mapMutations([]),

},

created: function() {
}

}
</script>
<style scoped>
</style>
